<section id="hero" class="hero" data-spy-as="about">
  <div class="container hero-shell">
     <div class="hero-copy">
       <h1>Turn Your idea into<br>a Global Empire</h1>
      <p class="lead">
        Tricore Holdings is a sector-agnostic venture building platform. We partner with bold entrepreneurs across Technology, Media, Textiles, Agriculture and beyond to transform high-potential ideas into market-leading legacies. We don’t just provide capital; we provide the strategic architecture for dominance.
      </p>
      <div class="hero-actions">
        <button class="btn-primary" type="button" (click)="scrollTo('projects')">Explore</button>
      </div>

      <div class="hero-metrics" aria-label="Company highlights">
        <div class="metric-item" *ngFor="let milestone of heroMilestones">
          <p class="metric-value">{{ milestone.displayValue }}</p>
          <span class="metric-line"></span>
          <p class="metric-label">{{ milestone.label }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="about" class="scroll-section about-section reveal-section">
  <app-about-us></app-about-us>
</section>

<section id="services" class="scroll-section services-section reveal-section">
  <app-services></app-services>
</section>

<section id="projects" class="scroll-section reveal-section">
  <app-projects></app-projects>
</section>

<section class="scroll-section vision-section reveal-section">
  <div class="container vision-inner">
    <p class="eyebrow">Our Vision</p>
    <h2>To lead as a tech driven ecosystem of ventures.</h2>
    <p>
      We aim to redefine how businesses grow in the digital age by combining execution strength,
      operational clarity, and scalable technology across every venture we build.
    </p>
  </div>
</section>

<section id="reviews" class="scroll-section reviews-section reveal-section">
  <app-reviews></app-reviews>
</section>

<section class="scroll-section closing-section reveal-section">
  <div class="closing-shell">
    <div class="closing-inner">
      <h2>No Sector is Off-Limits. No Ambition is Too Big</h2>
      <p>
        Whether you are holding a blueprint for a textile mill, a strategy for agricultural reform, or a plan for the next digital revolution, Tricore is your platform for growth. Bring your industry expertise. Use our venture engine. Build your empire.
      </p>
      <div class="closing-actions">
        <button class="btn-primary" type="button" (click)="scrollTo('projects')">
          Explore our ventures
        </button>
        <a class="btn-ghost" routerLink="/contact-us">Grow with Tricore</a>
      </div>
    </div>
  </div>
</section>
